// extracted by mini-css-extract-plugin
export default {"status":"Status_status__WMNB-","sm":"Status_sm__Iu-TU","color":"Status_color__LT8lB","green":"Status_green__saVuN","red":"Status_red__BT9xf"};